import { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import Loader from 'react-loader-spinner'
import { eduPaymentSummary } from 'services/api/course_payment/index'
import CustomHelmet from 'components/smart/CustomHelmet'

const FundingOption = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [courseData, setCourseData] = useState(null)

    const getCourseData = async (id) => {
        try {
            setLoading(true)
            const res = await eduPaymentSummary(id)
            if (res.data.payment_settled === 1) {
                navigate('/upskill-payment')
                return
            }
            setCourseData(res.data)
        } catch (e) {
            console.error(e)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getCourseData(id)
    }, [id])

    if (loading || !courseData) {
        return (
            <div className="flex h-screen items-center justify-center">
                <Loader type="Oval" color="#09b7b7" height={55} width={55} />
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-adx-gray px-4 py-12">
            <CustomHelmet title="Funding Option | adnexio EDU" />
            <div className="mx-auto max-w-2xl">
                <div className="mb-12 flex justify-center">
                    <img src={'/logo_adnexio.png'} className="h-10" alt="adnexio_logo" />
                </div>

                <div className="rounded-2xl bg-white p-4 shadow-sm lg:p-8">
                    <div className="mb-8 flex items-center space-x-4">
                        <img
                            src={courseData.course_logo || "/logo_adnexio.png"}
                            alt="course_logo"
                            className="h-16 w-16 rounded-xl object-contain"
                        />
                        <h2 className="text-xl font-bold text-[#F3BF3A]">{courseData.course_title}</h2>
                    </div>

                    <div className="mb-8 h-px bg-gray-200" />

                    <h3 className="mb-2 text-2xl font-bold text-gray-900">Select Funding Option</h3>
                    <p className="mb-8 text-gray-600">Please choose how you would like to fund this course.</p>

                    <div className="space-y-4">
                        <button
                            onClick={() => navigate(`/sponsorship-inquiry/${id}`)}
                            className="w-full rounded-xl border-2 border-gray-100 p-6 text-left transition-all hover:border-[#F3BF3A] hover:bg-orange-50 focus:outline-none"
                        >
                            <h4 className="mb-1 text-lg font-bold text-gray-900">Yayasan Peneraju Sponsor</h4>
                            <p className="text-sm text-gray-500">
                                Get sponsored by Yayasan Peneraju (Bumiputera only)
                            </p>
                        </button>

                        <button
                            onClick={() => navigate(`/payment-summary/${id}?self_funded=true`)}
                            className="w-full rounded-xl border-2 border-gray-100 p-6 text-left transition-all hover:border-[#F3BF3A] hover:bg-orange-50 focus:outline-none"
                        >
                            <h4 className="mb-1 text-lg font-bold text-gray-900">Self Funded</h4>
                            <p className="text-sm text-gray-500">
                                Pay for the course yourself with up to 50% discount
                            </p>
                        </button>
                    </div>

                    <div className="mt-12 text-center">
                        <Link to="/courses" className="text-sm font-medium text-blue-500 hover:underline">
                            Return To Course Details
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FundingOption
